import { IconProps } from './types';

type Props = {
    direction: 'up' | 'down' | 'left' | 'right'; // Define the direction prop
};

const Arrow = ({
    className,
    direction,
    strokeWidth,
}: IconProps & Props): JSX.Element => {
    const rotationMap: { [key in 'up' | 'down' | 'left' | 'right']: string } = {
        up: 'rotate(180deg)',
        down: 'rotate(0deg)',
        left: 'rotate(90deg)',
        right: 'rotate(-90deg)',
    };

    return (
        <svg
            width="24"
            height="24"
            viewBox="0 0 24 24"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
            aria-hidden
            role="img"
            className={className}
            style={{ transform: rotationMap[direction] }}
            stroke="currentColor"
            strokeWidth={strokeWidth}
        >
            <path
                color="currentColor"
                strokeLinecap="round"
                strokeLinejoin="round"
                d="M12 3.75v16.5M5.25 13.5 12 20.25l6.75-6.75"
            />
        </svg>
    );
};

export default Arrow;
